<template>
  <div>
    <title-edit header="User" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8"  xs="12" style="text-align: right">
        <v-app class="switch-app">
          <v-switch label="Active" v-model="form.status"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Username* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.username"
                          @update="updateUsername"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Password* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field inputType="password" :model="form.password"
                          @update="updatePassword"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Confirm password* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <div style="color: red; font-size: 13px" v-if="msg_alert">*{{msg_alert}}</div>
        <input-text-field inputType="password"
                          @update="updateConfirmPassword"
                          :model="form.c_password"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>First name* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.firstname" @update="updateFirstName"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Last name* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.lastname" @update="updateLastName"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>E-mail* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.email" @update="updateEmail"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>User role* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option :items="userRole" :model="form.user_role_id" @update="updateUserRole"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Profile image* :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 500KB
        </div>
      </v-col>
      <v-col cols="12" sm="4"  xs="12">
        <input-image-upload id="profile_image"
                            :model="form.profile_image_show"
                            @update="updateProfileImage"
                            width="150px"
                            height="150px"/>
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteUser" @save-info="saveUser" @save-close="saveClose"></command-button>
<!--    <pre>{{form}}</pre>-->
  </div>
</template>

<script>
  import TitleEdit from "../../../components/TitleHeader/TitleEdit";
  import InputTextField from "../../../components/Input/InputTextField";
  import InputEditor from "../../../components/Input/InputEditor";
  import SelectOption from "../../../components/Input/selectOption";
  import InputImageUpload from "../../../components/Input/InputImageUpload";
  import LineHr from "../../../components/Icon/line-hr";
  import DeleteButton from "../../../components/Button/DeleteButton";
  import PreviewButton from "../../../components/Button/PreviewButton";
  import SaveButton from "../../../components/Button/SaveButton";
  import SwitchSelect from "../../../components/Input/StyleUtility";
  import { mapState } from "vuex";
  import Swal from "sweetalert";
  import CommandButton from "../../../components/Layout/CommandButton";
  export default {
    name: "UserEdit",
    components: {
      CommandButton,
      SwitchSelect,
      SaveButton,
      PreviewButton,
      DeleteButton,
      LineHr,
      InputImageUpload,
      SelectOption,
      InputEditor,
      InputTextField,
      TitleEdit
    },
    computed: {
      ...mapState({
        form: state => {
          return state.User.form;
        }
      })
    },
    created() {
      this.getUserRoleData();
    },
    data() {
      return {
        msg_alert : null,
        userRole : [],
        save_id: null
      };
    },
    methods: {
      getUserRoleData(){
        this.$store.dispatch("UserRole/getUserRoleAll").then(role=>{
          this.userRole = [
            ...role.map(data => ({
              value: data.id,
              text: data.role_name,
            }))
          ];
        })
      },
      goToUserTable() {
        this.$router.push("/user");
      },
      validateSave() {
        if(!this.form.username){
          Swal('','Please input username','error');
          return false;
        }else if(!this.form.id && !this.form.password){
          Swal('','Please input password','error');
          return false;
        }else if(!this.form.id && !this.form.c_password){
          Swal('','Please input confirm password','error');
          return false;
        }else if(!this.form.firstname){
          Swal('','Please input firstname','error');
          return false;
        }else if(!this.form.lastname){
          Swal('','please input lastname','error');
          return false;
        }
        else if(!this.form.user_role_id){
          Swal('','Please select role','error');
          return false;
        }
        else if(this.form.password !== this.form.c_password){
          Swal('','Password and confirm password does not match','error');
          this.msg_alert = 'password and confirm password does not match';
          return false;
        }
        return true;
      },
      saveClose() {
        if(this.validateSave()){
          this.$store.dispatch("User/saveUser",{
            id : this.save_id ? this.save_id : this.form.id,
            data : this.form
          }).then(res=>{
            Swal(res.response_msg);
            if(res.response_code == 200){
              this.goToUserTable();
            }
          }).catch(()=>{
            Swal('','Cannot save user','error');
          })
        }
      },
      saveUser() {
        if(this.validateSave()){
          this.$store.dispatch("User/saveUser",{
            id : this.save_id ? this.save_id : this.form.id,
            data : this.form
          }).then(res=>{
            this.save_id = res.result.id;
            Swal(res.response_msg);
          }).catch(()=>{
            Swal('','Cannot save user','error');
          })
        }
      },
      deleteUser() {
        this.$store.dispatch("User/deleteUser",this.form.id).then(res=>{
          Swal(res.response_msg);
          if(res.response_code == 200){
            this.goToUserTable();
          }
        }).catch(()=>{
          Swal('','Cannot delete user','error');
        })
      },
      updateUsername(val) {
        this.form.username = val;
      },
      updateFirstName(val) {
        this.form.firstname = val;
      },
      updateLastName(val) {
        this.form.lastname = val;
      },
      updatePassword(val) {
        this.form.password = val;
      },
      updateConfirmPassword(val) {
        this.form.c_password = val;
      },
      updateEmail(val) {
        this.form.email = val;
      },
      updateUserRole(val) {
        this.form.user_role_id = val;
      },
      updateProfileImage(val) {
        this.form.profile_image = val.imagePath;
        this.form.profile_image_show = val.fullImagePath;
      }
    }
  };
</script>

<style scoped>
  .label {
    text-align: right;
  }
</style>
